import React from "react";
import { useLocation } from "react-router-dom";

import ChatBubbleHints from "../../../templates/teacher/ChatBubbleHints";
import ChatBubbleTeacherSurvey from "../../../templates/teacher/ChatBubbleTeacherSurvey";
import {
  Context,
  updateTeacherSurvey,
  createTeacherSurvey,
  fetchTeachingHintsGroupWorks,
  fetchTeachingHintsIntroductions,
} from "../../../teacherStore";
import { parseQueryParams } from "../../../libs/Util";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import { ISubmitTeacherSurvey } from "../../../state";
import {
  CHAT_BUBBLE_MODAL_PAGES,
  TEACHING_HINTS_MODAL_PAGES,
  ChatBubbleModalPage,
} from "../../../constants/teaching_hint";

type Props = {
  onClose: () => void;
  modalPage: ChatBubbleModalPage;
  setModalPage: React.Dispatch<React.SetStateAction<ChatBubbleModalPage>>;
  isInitialShowChat?: boolean;
};

const ChatBubblePage: React.FC<Props> = props => {
  const lessonId = parseInt(parseQueryParams()["lesson"]);
  const { state, dispatch } = React.useContext(Context);
  const { modalPage, setModalPage } = props;
  const { pathname } = useLocation();
  const [calling, peep] = useWaitApiCall(state);
  const teachingHintModalPages = props.isInitialShowChat
    ? TEACHING_HINTS_MODAL_PAGES.INTRODUCTION
    : undefined;

  const onUpdateTeacherSurvey = (teacherSurvey: ISubmitTeacherSurvey) => {
    dispatch(peep(updateTeacherSurvey(teacherSurvey)));
  };

  const onCreateTeacherSurvey = (teacherSurvey: ISubmitTeacherSurvey) => {
    dispatch(peep(createTeacherSurvey(teacherSurvey)));
  };

  React.useEffect(() => {
    setModalPage(
      pathname.includes("guideline")
        ? CHAT_BUBBLE_MODAL_PAGES.HINTS
        : CHAT_BUBBLE_MODAL_PAGES.SURVEY,
    );
  }, [pathname, setModalPage]);

  React.useEffect(() => {
    if (modalPage === CHAT_BUBBLE_MODAL_PAGES.HINTS) {
      dispatch(fetchTeachingHintsIntroductions(lessonId));
      dispatch(fetchTeachingHintsGroupWorks(lessonId));
    }
  }, [dispatch, lessonId, modalPage]);

  return (
    <div className="w-100 h-100">
      {modalPage === CHAT_BUBBLE_MODAL_PAGES.HINTS ? (
        <ChatBubbleHints
          onClose={props.onClose}
          teachingHint={state.teaching_hint_introduction}
          teachingHintGroupWork={state.teaching_hint_group_work}
          teacherSurvey={state.teacher_survey}
          onNavigateToSurvey={() =>
            setModalPage(CHAT_BUBBLE_MODAL_PAGES.SURVEY)
          }
          teachingHintModalPages={teachingHintModalPages}
        />
      ) : (
        <ChatBubbleTeacherSurvey
          onClose={props.onClose}
          onUpdateTeacherSurvey={onUpdateTeacherSurvey}
          onCreateTeacherSurvey={onCreateTeacherSurvey}
          calling={calling}
          teacherSurvey={state.teacher_survey}
          pathname={pathname}
        />
      )}
    </div>
  );
};

export default ChatBubblePage;
